<template>
    <div>
        <div class="empty" v-if="bus.code != 83001003">
            <btn type="primary" :type="0" info="去登录" @click="gotoLogin"></btn>
        </div>
        <div v-else class="noPermission">该账号不是小程序企业，无管理权限</div>
    </div>
</template>
<script>
import Btn from './Button';
import bus from '@/lib/bus.js';
export default {
    props: {
        code: {
            type: Number,
            default: 0
        }
    },
    components: {
        Btn
    },
    data() {
        return {
            bus
        };
    },
    methods: {
        gotoLogin() {
            location.href = 'https://passport.bilibili.com/login?gourl=' + location.href;
        }
    }
}
</script>
<style lang="less" scoped>
.empty {
    padding-top: 245px;
    background: url(./../assets/login.png) center 40px no-repeat;
    background-size: 205px 205px;
    text-align: center;
}
.noPermission {
    padding-top: 164px;
    font-size: 14px;
    color: #5C667E;
    text-align: center;
    background: url(./../assets/no-permission.png) center 0 no-repeat;
    background-size: 168px 152px;
    margin-top: 83px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AccessDeny.vue